import { render, staticRenderFns } from "./bar-basic.vue?vue&type=template&id=482a5627"
import script from "./bar-basic.vue?vue&type=script&lang=js"
export * from "./bar-basic.vue?vue&type=script&lang=js"
import style0 from "./bar-basic.vue?vue&type=style&index=0&id=482a5627&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports